import React from "react";
import { Dialog, IconButton } from "@mui/material";
import { ArrowRight, PhoneOutgoing, Route as RouteIcon, X } from "lucide-react";

const CHOICES = [
  {
    id: "inbound",
    title: "Set up inbound call routing",
    description:
      "Decide what happens when someone calls your number — forward, voicemail, AI agent, and more.",
    icon: RouteIcon,
  },
  {
    id: "outbound",
    title: "Place an outbound call",
    description:
      "Jump into the dialer and make your first call from Twilanswer.",
    icon: PhoneOutgoing,
  },
];

/**
 * Post-Twilio onboarding choice: inbound routing help vs outbound dialer.
 */
const WhatNextModal = ({ open, onClose, onChooseInbound, onChooseOutbound }) => {
  const handleClose = () => {
    onClose?.();
  };

  const handleChoose = (id) => {
    if (id === "inbound") onChooseInbound?.();
    else if (id === "outbound") onChooseOutbound?.();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
      PaperProps={{
        sx: { borderRadius: "12px", overflow: "hidden" },
      }}
    >
      <div className="relative lg:px-10 px-5 lg:pt-10 pt-8 lg:pb-10 pb-8">
        <IconButton
          aria-label="Close"
          onClick={handleClose}
          sx={{ position: "absolute", top: 12, right: 12 }}
          size="small"
        >
          <X className="w-5 h-5 text-gray-400" />
        </IconButton>

        <div className="text-center mb-8 max-w-lg mx-auto">
          <h2 className="lg:text-[24px] text-[20px] font-semibold text-[#030229] mb-2">
            What would you like to do first?
          </h2>
          <p className="lg:text-[15px] text-[14px] text-gray-600">
            Twilio is connected. Pick a starting point — you can always do the
            other later.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {CHOICES.map(({ id, title, description, icon: Icon }) => (
            <button
              key={id}
              type="button"
              onClick={() => handleChoose(id)}
              className="group w-full text-left flex items-start gap-4 rounded-[8px] border border-gray-200 bg-white px-5 py-5 transition hover:border-[#605BFF]/40 hover:bg-[rgba(96,91,255,0.1)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#605BFF]/50"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[8px] bg-[rgba(96,91,255,0.1)] text-[#605BFF]">
                <Icon className="w-[20px] h-[20px]" />
              </div>
              <div className="min-w-0 flex-1 pt-0.5">
                <div className="flex items-center justify-between gap-2">
                  <span className="lg:text-[17px] text-[15px] font-semibold text-[#030229] group-hover:text-[#605BFF]">
                    {title}
                  </span>
                  <ArrowRight className="w-5 h-5 shrink-0 text-gray-300 transition group-hover:text-[#605BFF] group-hover:translate-x-0.5" />
                </div>
                <p className="mt-1 lg:text-[14px] text-[13px] text-gray-600 leading-snug">
                  {description}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </Dialog>
  );
};

export default WhatNextModal;
